import React from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import "./premiumAdsSlideshow.css";
import { Link } from "react-router-dom";
import { BsFillStarFill } from "react-icons/bs";
import { ClassifiedType } from "../../../types/main-types/mainTypes";
import noImageAvailable from "../../../assets/images/no_image_available.png";
import TrustedMemberBadge from "../../common/trsuted-member-badge/TrustedMemberBadge";
import premiumBadge from "../../../assets/images/premium-badge.png";

interface PremiumAdsSlideshowProps {
  premiumAdList: ClassifiedType[];
}

function PremiumAdsSlideshow({ premiumAdList }: PremiumAdsSlideshowProps) {
  const defaultImgStyles = {
    backgroundImage: `url(${noImageAvailable})`,
    backgroundSize: "auto",
    backgroundPosition: "center",
  };
  return (
    <div className="mb-3">
      <Slide
        arrows={premiumAdList?.length === 1 ? false : true}
        autoplay={premiumAdList?.length === 1 ? false : true}
      >
        {premiumAdList?.map((premiumAd, index) => (
          <div key={index} className="div-link-no-decoration">
            <Link to={`/ads/${premiumAd.id}`}>
              <div className="each-slide-effect">
                <div
                  style={
                    premiumAd?.image_urls
                      ? {
                          backgroundImage: `url(${premiumAd?.image_urls[0]})`,
                        }
                      : defaultImgStyles
                  }
                >
                  <div className="premium-listing-details-container">
                    <div className="premium-icon-wrapper glass">
                      <img
                        src={premiumBadge}
                        alt="premium badge"
                        className="w-100"
                      />
                    </div>
                    <div className="premium-listing-details-wrapper">
                      <h4 className="m-0">
                        {premiumAd?.model +
                          " " +
                          premiumAd?.make +
                          " " +
                          premiumAd?.year}
                      </h4>
                      <h6 className="mb-2">
                        Rs{" "}
                        {premiumAd?.price && premiumAd?.price.toLocaleString()}
                      </h6>
                      <div>
                        {premiumAd?.seller_profile?.verified && (
                          <TrustedMemberBadge />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </Slide>
    </div>
  );
}

export default PremiumAdsSlideshow;
